enum InvoiceStatus {
  PENDING = 'PENDING',
  SENT = 'SENT',
  PROCESSED = 'PROCESSED',
}

export default InvoiceStatus;
